import React from 'react';
import { Link } from 'react-router-dom';
import fallbackCoinIcon from '../assets/biticon.png';
import { formatCurrency, formatPercent } from '../helpers/formatters';

export default function Hero({ coins, loading }) {
  return (
    <section className="hero-section">
      <div className="width hero-shell">
        <div className="hero-copy">
          <p className="eyebrow">Crypto market monitor</p>
          <h2>
            Track the market effectively.
          </h2>
          <p className="hero-copy__text">
            Live market data to give you a strategic edge.
          </p>
        </div>

        <div className="hero-panel">
          <div className="hero-panel__header">
            <span>Top market movers</span>
            <span>USD</span>
          </div>

          <div className="hero-grid">
            {loading
              ? Array.from({ length: 4 }).map((_, index) => (
                  <div className="hero-card skeleton" key={index} aria-hidden="true" />
                ))
              : coins.map((coin) => (
                  <Link key={coin.id} to={`/${coin.id}`} className="hero-card">
                    <div className="hero-card__identity">
                      <img
                        src={coin.image}
                        alt={coin.name}
                        loading="lazy"
                        onError={(event) => {
                          event.currentTarget.onerror = null;
                          event.currentTarget.src = fallbackCoinIcon;
                        }}
                      />
                      <div>
                        <strong>{coin.name}</strong>
                        <span>{coin.symbol || 'COIN'}</span>
                      </div>
                    </div>

                    <div className="hero-card__price">{formatCurrency(coin.currentPrice)}</div>

                    <div
                      className={`hero-card__change ${
                        coin.priceChange24h >= 0 ? 'green-text' : 'red-text'
                      }`}
                    >
                      {formatPercent(coin.priceChange24h)}
                    </div>
                  </Link>
                ))}
          </div>
        </div>
      </div>
    </section>
  );
}
